import 'jquery-ui';

const handleHeaderAutocomplete = () => {
	const $autocomplete = $('.js-autocomplete');
	const $autocompleteContainer = $('.js-header-search');

    if ($autocomplete.length) {
        $autocomplete.autocomplete({
                minLength: 3,
                delay: 100,
                source: function(request, response) {
                    $.ajax('/boss-api/getautocompleteproductlist?searchTerm=' + request.term,
                        {
                            type: 'GET',
                            success: function(output) {
                                let data = [];
                                var result = JSON.parse(output);
                                $.each(result,
                                    function(key, value) {
                                        if (key == "productCollection" && value != null) {
                                            $.each(value,
                                                function(i, val) {
                                                    data.push(
                                                        { label: val.erpNumber + " " + val.title, value: val.url });
                                                    if (request.term == val.erpNumber) {
                                                        $('.autoRedirect').val("true");
                                                    }
                                                    else {
                                                        $('.autoRedirect').val("false");
                                                    }
                                                });
                                            if (result.count > 5) {
                                                data.push({ label: "View All ", value: "View_All" });
                                            }
                                            response(data);
                                        }
                                    });
                            }
                        });
                },
                focus: function(event, ui) {
                    //comented below line as it was updating orignal search text
                    //$autocomplete.val( ui.item.label );
                    return false;
                },
                open: function(event, ui) {
                    $autocompleteContainer.addClass('is-active');

                    return false;
                },
                close: function(event, ui) {
                    $autocompleteContainer.removeClass('is-active');

                    return false;
                },
                select: function(event, ui) {
                    if (ui.item.value == "View_All") {
                        let lang = '/' + $("#lang").val();
                        let searchtext = $(".search__input").val();
                        let loc = lang + "/search?q=" + searchtext + "&activetab=%23products";
                        $("#search-form").attr('action', loc);
                        $("#search-form").submit();
                    } else {
                        $autocomplete.val(ui.item.label);
                        $('.js-autocomplete-id').val(ui.item.value);
                        $autocompleteContainer.removeClass('is-active');
                        window.location.href = ui.item.value;
                    }
                    return false;
                }
            })
            .autocomplete('instance')._renderItem = function(ul, item) {
                ul.prependTo('.js-header-search .search__options');

                return $('<li>')
                    .append('<div>' + item.label + '</div>')
                    .appendTo(ul)
            };
    }
};

handleHeaderAutocomplete();
